import { angularServicesNames } from "@topline/services/angularServicesNames";
import { Gen } from "@topline/services/api";
import { ApiClient, MarketClient, wrapPromiseWithStatus } from "@topline/services/apiService";

export class MarketEditService {
    static componentName = "MarketEditService";
    static $inject = [
        "AlertService",
        angularServicesNames.$translate,
        "$q",
        MarketClient.componentName,
        ApiClient.componentName
    ];

    constructor(
        protected alertService: AlertService,
        protected $translate: ng.translate.ITranslateService,
        protected $q: ng.IQService,
        protected marketClient: MarketClient,
        protected client: ApiClient
    ) {}

    save(market: $TSFixMe) {
        return this.marketClient.editImsMarket({ market });
    }

    saveNewProducts(market: $TSFixMe) {
        console.log(market);
        return this.marketClient.updateNewProductsInImsMarket({
            marketId: market.id,
            productCodes: market.newProductsOracleIndex
        });
    }

    saveAndFinish(market: $TSFixMe, type: $TSFixMe) {
        let savePromise;
        if (type === "ims") {
            savePromise = this.marketClient.editImsMarket({ market });
        } else if (type === "file") {
            savePromise = this.marketClient.editFileMarket({ market });
        } else if (type === "scoringCards") {
            savePromise = this.marketClient.editScoringCardsMarket({ market });
        } else if (type === "scoringCardsPoland") {
            savePromise = this.marketClient.editScoringCardsPolandMarket({ market });
        } else {
            return this.$q.reject("Unknown market type: " + type);
        }

        return savePromise.then(() => this.toggleMarketFinished(market.id, true));
    }

    saveFileMarket(market: $TSFixMe) {
        return this.marketClient.editFileMarket({ market });
    }

    getSimilarNeeds = () => this.marketClient.getSimilarNeeds().then(data => data);

    checkIMSMarketRequirements = (filters: $TSFixMe, kamsoftMarketType: $TSFixMe) =>
        this.marketClient.checkIMSMarketRequirements({
            filters,
            kamsoftMarketType
        });

    checkScoringCardsPolandMarketRequirements = (filters: $TSFixMe, kamsoftMarketType: $TSFixMe) =>
        this.marketClient.checkScoringCardsPolandMarketRequirements({
            filters,
            kamsoftMarketType
        });

    saveScoringCardsMarket = (market: $TSFixMe) => this.marketClient.editScoringCardsMarket({ market });

    saveScoringCardsPolandMarket = (market: $TSFixMe) => this.marketClient.editScoringCardsPolandMarket({ market });

    create = (type: $TSFixMe) => {
        if (type === "ims") {
            return this.marketClient.createImsMarket();
        } else if (type === "file") {
            return this.marketClient.createFileMarket();
        } else if (type === "scoringCards") {
            return this.marketClient.createScoringCardsMarket();
        } else if (type === "scoringCardsPoland") {
            return this.marketClient.createScoringCardsPolandMarket();
        }
        return this.$q.reject("Unknown market type: " + type);
    };

    get = (id: $TSFixMe) => wrapPromiseWithStatus(this.marketClient.getImsMarket(id));

    getFileBased = (id: $TSFixMe) => wrapPromiseWithStatus(this.marketClient.getFileMarket(id));

    getScoringCardBased = (id: $TSFixMe) => wrapPromiseWithStatus(this.marketClient.getScoringCardMarket(id));

    getScoringCardPolandBased = (id: $TSFixMe) =>
        wrapPromiseWithStatus(this.marketClient.getScoringCardMarketPoland(id));

    clone = (id: $TSFixMe, resultObj: $TSFixMe) => this.marketClient.copyMarket(id, resultObj);

    getSkusInMarkets = (marketIds: $TSFixMe) => this.marketClient.getMarketsSkus({ marketIds });

    toggleActivity = (id: $TSFixMe) => this.marketClient.toggleMarketActivity(id);

    delete = (id: $TSFixMe) => this.marketClient.removeMarket(id);

    canEdit = (id: $TSFixMe) => this.marketClient.marketIsEditable(id);

    toggleMarketFinished = (id: $TSFixMe, status: $TSFixMe) =>
        wrapPromiseWithStatus(this.marketClient.setMarketAsReadyToExport(id, status));

    changeProductManager = (marketId: $TSFixMe, productManagerMsnuId: $TSFixMe) =>
        this.marketClient.changeMarketProductManager({
            marketId,
            productManagerMsnuId
        });

    displaySaveMarketError(err: $TSFixMe, market: $TSFixMe) {
        switch (err.status) {
            case HttpStatus.Conflict:
                this.alertService.error(
                    this.$translate.instant("MARKET.MARKET_FINISHED_STATUS_IS_REALLY_CHANGED", market)
                );
                break;
            case HttpStatus.NotAcceptable:
                this.alertService.error(
                    this.$translate.instant(
                        "MARKET.MARKET_WITH_SAME_NAME_AND_FINISHED_STATUS_EXIST",
                        Object.assign({}, market, { ["type"]: this.$translate.instant(`DATA_SOURCES.${market.type}`) })
                    )
                );
                break;
            case HttpStatus.PreconditionFailed:
                this.alertService.error(
                    this.$translate.instant("MARKET.MARKET_USED_IN_APPROVED_FORECAST", {
                        forecastNames: err.data.join(","),
                        name: market.name,
                        version: market.version
                    })
                );
                break;
        }
    }

    validateToggleMarketsFinished = (markets: $TSFixMe) =>
        this.marketClient.validateMarketGroupFinish({
            marketIds: markets.map((m: $TSFixMe) => m.id)
        });

    toogleMarketsFinished(markets: $TSFixMe, finishStatus: $TSFixMe) {
        const promises = markets.map((market: $TSFixMe) =>
            wrapPromiseWithStatus(this.marketClient.setMarketAsReadyToExport(market.id, finishStatus)).catch(error => {
                return {
                    status: error.status || 500,
                    config: { market },
                    data: error.data
                };
            })
        );
        return Promise.all(promises).then((results: $TSFixMe) => {
            for (const result of _.filter(results, (r: $TSFixMe) => r.status > 299)) {
                this.displaySaveMarketError(result, result.config.market);
            }
        });
    }

    checkMarketMetsRequirements = (marketId: $TSFixMe) =>
        this.marketClient
            .checkMarketRequirements({ marketIds: [marketId] })
            .then((response: $TSFixMe) => response.length === 0);
}

angular.module("topline.modules").service(MarketEditService.componentName, MarketEditService);
